import { Flex, Modal } from "@mantine/core";
import type { FC, PropsWithChildren } from "react";

interface AsideModalProps extends PropsWithChildren {
  opened: boolean;
  onClose: () => void;
  title: string;
  size: string;
  asideRatio?: number;
  asideVisibleFrom?: "sm" | "md" | "lg" | "xl" | "xs";
  aside: React.ReactNode;
}

export const AsideModal: FC<AsideModalProps> = ({
  opened,
  onClose,
  title,
  size,
  asideVisibleFrom,
  aside,
  children,
  asideRatio = 70,
}) => {
  const asideFlex = `1 1 ${asideRatio}%`;
  const mainFlex = `1 1 calc(100% - ${asideRatio}%)`;

  return (
    <Modal.Root opened={opened} onClose={onClose} size={size}>
      <Modal.Overlay />
      <Modal.Content>
        <Flex align="flex-start">
          <Flex direction="column" flex={asideFlex} visibleFrom={asideVisibleFrom}>
            <Modal.Body p="0px">
              {aside}
            </Modal.Body>
          </Flex>

          <Flex direction="column" miw="40ch" flex={mainFlex}>
            <Modal.Header>
              <Modal.Title>
                {title}
              </Modal.Title>
              <Modal.CloseButton />
            </Modal.Header>

            <Modal.Body>
              {children}
            </Modal.Body>
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal.Root>
  );
};
